import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import TabbedNavigation from 'common/components/tabbed_navigation';

export function mapStateToProps(_, { router }) {
  return {
    router,
    rightDropdown: true
  };
}

export default withRouter(connect(mapStateToProps, { push })(TabbedNavigation));



// WEBPACK FOOTER //
// ./project/containers/access_tabs.js